import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { ExtLayoutComponent } from './layouts/ext-layout/ext-layout.component';
import { ContractorManagerLayoutComponent } from './layouts/contractor-manager-layout/contractor-manager-layout.component';
import { SiteOwnerLayoutComponent } from './layouts/site-owner-layout/site-owner-layout.component';
import { SiteDelegateLayoutComponent } from './layouts/site-delegate-layout/site-delegate-layout.component';
import { AuthorisingOfficerLayoutComponent } from './layouts/authorising-officer-layout/authorising-officer-layout.component';
import { SupportLayoutComponent } from './layouts/support-layout/support-layout.component';
import { WorkerLayoutComponent } from './layouts/worker-layout/worker-layout.component';
import { AuthGuard } from './_guards/auth.guard';
import { UserRoleGuard } from './_guards/user-role.guard';
import { PowerStationOwnerLayoutComponent } from './layouts/power-station-owner/power-station-owner-layout.component';
import { PowerStationManagerLayoutComponent } from './layouts/power-station-manager/power-station-manager-layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/signin',
    pathMatch: 'full',
  }, {
    path: '',
    component: ExtLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/ext-layout/ext-layout.module').then(m => m.ExtLayoutModule)
      }]
  },
  {
    path: 'admin',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: ['admin'] },
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule)
      }]
  },
  {
    path: 'support',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: ['support'] },
    component: SupportLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/support-layout/support-layout.module').then(m => m.SupportLayoutModule)
      }]
  },
  {
    path: 'contractor-manager',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: ['contractor-manager'] },
    component: ContractorManagerLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/contractor-manager-layout/contractor-manager-layout.module').then(m => m.ContractorManagerLayoutModule)
      }]
  },
  {
    path: 'site-owner',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: ['site-owner'] },
    component: SiteOwnerLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/site-owner-layout/site-owner-layout.module').then(m => m.SiteOwnerLayoutModule)
      }]
  },
  {
    path: 'power-station-owner',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: ['power-station-owner'] },
    component: PowerStationOwnerLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/power-station-owner/power-station-owner-layout.module').then(m => m.PowerStationOwnerLayoutModule)
      }]
  },
  {
    path: 'power-station-manager',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: ['power-station-manager'] },
    component: PowerStationManagerLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/power-station-manager/power-station-manager-layout.module').then(m => m.PowerStationManagerLayoutModule)
      }]
  },
  {
    path: 'site-delegate',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: ['site-delegate'] },
    component: SiteDelegateLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/site-delegate-layout/site-delegate-layout.module').then(m => m.SiteDelegateLayoutModule)
      }]
  },
  {
    path: 'authorising-officer',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: ['authorising-officer'] },
    component: AuthorisingOfficerLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/authorising-officer-layout/authorising-officer-layout.module').then(m => m.AuthorisingOfficerLayoutModule)
      }]
  },
  {
    path: 'worker',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: ['worker'] },
    component: WorkerLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/worker-layout/worker-layout.module').then(m => m.WorkerLayoutModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/not_found'
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })
  ],
  exports: [
  ],
  providers: [
  ],
})
export class AppRoutingModule { }
